// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_w5Hla","space21":"index_space21_-ENFL","space50":"index_space50_kjDbD","atlasBox":"index_atlasBox_wa5-0"};